import { AuditCard, CrawlCard, HarnessCard } from "./Settings.js";

/** 시스템 — 하네스 판정 · 수집 상태 · 감사 로그. 판정이 없으면 없다고 말한다 (SOUL S2) */
export function System() {
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">≡</span>
        <div>
          <h1>시스템</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            하네스 8종의 마지막 판정, SECUI 수집 상태, 감사 로그.
          </p>
        </div>
      </div>
      <HarnessCard />
      <CrawlCard />
      <AuditCard />
    </>
  );
}
